import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { ArrowLeft } from "lucide-react";
import { toast } from "../hooks/use-toast";

const Enquire = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    tourInteres: "",
    mensaje: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "¡Reserva Recibida!",
      description: "Nos pondremos en contacto contigo pronto para confirmar tu tour."
    });
    setTimeout(() => navigate("/"), 2000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate("/")}
          className="mb-8 hover:bg-gray-200 transition-colors"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Volver
        </Button>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold mb-4 text-gray-900">
            Reserva Tu Tour con Agente 360
          </h1>
          <p className="text-gray-600 mb-8 text-lg">
            Completa el formulario y nos pondremos en contacto contigo para planificar tu experiencia formativa en Europa.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="nombre">Nombre Completo</Label>
              <Input
                id="nombre"
                name="nombre"
                required
                value={formData.nombre}
                onChange={handleChange}
                className="h-12"
              />
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="h-12"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="telefono">Teléfono</Label>
                <Input
                  id="telefono"
                  name="telefono"
                  type="tel"
                  required
                  value={formData.telefono}
                  onChange={handleChange}
                  className="h-12"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="tourInteres">Tour de Interés</Label>
              <Input
                id="tourInteres"
                name="tourInteres"
                placeholder="Ej: Tour España, Semana Intensiva Premier League..."
                value={formData.tourInteres}
                onChange={handleChange}
                className="h-12"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="mensaje">Mensaje</Label>
              <Textarea
                id="mensaje"
                name="mensaje"
                required
                value={formData.mensaje}
                onChange={handleChange}
                rows={6}
                placeholder="Cuéntanos sobre tus objetivos y qué esperas aprender en el tour..."
              />
            </div>

            <Button
              type="submit"
              className="w-full h-14 text-lg bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-gray-900 font-semibold shadow-lg transition-all duration-300 hover:shadow-xl"
            >
              Enviar Reserva
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Enquire;
